import { Route, Routes, Navigate } from 'react-router-dom';
import { CreateAttatchFileFormTestPage } from '../../pages/Officer/CreateAttatchFileFormTestPage';
import { CreateAttatchFileFormTrainPage } from '../../pages/Officer/CreateAttatchFileFormTrainPage';
import { CreateBorrowFormPage } from '../../pages/Officer/CreateBorrowFormPage';
import { CreateCompanyRegisterPage } from '../../pages/Officer/CreateCompanyRegisterPage';
import { CreateFormTestPage } from '../../pages/Officer/CreateFormTestPage';
import { CreateFormTrainPage } from '../../pages/Officer/CreateFormTrainPage';
import { CreateJobPositionFormTestPage } from '../../pages/Officer/CreateJobPositionFormTestPage';
import { CreateJobPositionFormTrainPage } from '../../pages/Officer/CreateJobPositionFormTrainPage';
import { CreatePersonalRegisterPage } from '../../pages/Officer/CreatePersonalRegisterPage';

export function AppOfficer() {

    return (

        <Routes>
            <Route
                path="/create-user-company"
                element={<CreateCompanyRegisterPage />}
            />
            <Route
                path="/create-user-personal"
                element={<CreatePersonalRegisterPage />}
            />

            <Route
                path="/create-borrowing"
                element={<CreateBorrowFormPage />}
            />
            {/* แบบฟอร์มกู้ยืมเงิน */}
            <Route
                path="/create-borrowing"
                element={<CreateBorrowFormPage />}
            />
            {/* แบบฟอร์มกู้ยืมเงิน สำหรับฝึกอบรม */}
            <Route
                path="/create-train-borrowing"
                element={<CreateFormTrainPage />}
            />

            <Route
                path="/create-train-files"
                element={<CreateAttatchFileFormTrainPage />}
            />

            <Route
                path="/create-train-job"
                element={<CreateJobPositionFormTrainPage />}
            />
            {/* ---------------------------- */}



            {/* แบบฟอร์มกู้ยืมเงิน สำหรับขอทดสอบ */}
            <Route
                path="/create-testing-borrowing"
                element={<CreateFormTestPage />}
            />

            <Route
                path="/create-testing-file"
                element={<CreateAttatchFileFormTestPage />}
            />

            <Route
                path="/create-testing-job"
                element={<CreateJobPositionFormTestPage />}
            />



            <Route path="*" element={<Navigate to="/" replace={true} />} />
        </Routes>

    );

}